var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{staticClass:"themBox",attrs:{"type":"flex","justify":"space-between"}},[_c('van-col',{attrs:{"span":"4"}},[_c('div',{staticClass:"TaskTheme"},[_vm._v("主题")])]),_c('van-col',{staticStyle:{"text-align":"left","font-size":"15px"},attrs:{"span":"20"}},[_vm._v(" "+_vm._s(_vm.themeText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }